import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { withRouter } from "react-router-dom";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Calendar from "react-calendar";
import DatePicker from "react-date-picker";

import arrowdown from "../../assets/Images/arrowdown.svg";
import Tile from "../Tile/Tile";
import CustomWorkout from "../CustomWorkout/CustomWorkout";
import Lift from "../Lift/Lift";
import style from "./ProgrammingCalendar.module.css";

import "react-calendar/dist/Calendar.css";

import { dateFormater } from "../../assets/Js/DateFormater";
import AddTracks from "../AddTracks/AddTracks";
import { Spinner } from "../../Components/Spinner/Spinner";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import { callAPI } from "../../assets/Js/backendCommunication";

import addTrackInfo from "../../redux/actionCreators/addTrackInfo";
import calendarDateChanged from "../../redux/actionCreators/calendarDateChanged";
import workoutApiCalled from "../../redux/actionCreators/workoutApiCalled";

import projectSettings from "../../assets/Js/projectSettings";
import FromDatabase from "../FromDatabase/FromDatabase";
import JoinGym from "../JoinGym/JoinGym";
import JoinTrack from "../JoinTrack/JoinTrack";
import { getSubscription } from "../../assets/Js/localStorage";
import { months } from "../../assets/Js/monthsEnum";
import selectGym from "../../redux/actionCreators/selectGym";

const mapDispatchToProps = (dispatch) => {
  return {
    addTrack: (data) => dispatch(addTrackInfo(data)),
    calendarDateChanged: (data) => dispatch(calendarDateChanged(data)),
    workoutApiCalled: () => dispatch(workoutApiCalled()),
    selectGym: (data) => dispatch(selectGym(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    newWorkoutAdded: state.workoutApiCalled,
    gymDataTrack: state.gymData,
    gymData: state.selectedGym,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    class ProgrammingCalendar extends Component {
      constructor(props) {
        super(props);

        this.state = {
          showCustomWorkout: true,
          showLift: false,
          showFromDB: false,
          showJoinGym: false,
          workoutDate: new Date(),
          showCalendar: false,
          startDate: { day: "", month: "", date: "", year: "" },
          endDate: { day: "", month: "", date: "", year: "" },
          today: { day: "", month: "", date: "", year: "" },
          selectedDate: { day: "", month: "", date: "", year: "" },
          selectedDateRaw: "current",
          weekDates: [],
          currentPosition: 0,
          selectedTrack: [],
          selectedGym: {},
          tracks: [],
          trackOptions: [],
          isShowViewWorkoutModal: false,
          workoutInfo: [],
          options: [],
          gyms: [],
        };

        let currentDate = new Date();
        let tempDay, tempMonth, tempDate, tempYear;
        [tempDay, tempMonth, tempDate, tempYear] = currentDate
          .toDateString()
          .split(" ");

        this.state.today = {
          day: tempDay,
          month: tempMonth,
          date: dateFormater(tempDate),
          year: tempYear,
        };

        this.state.selectedDate = {
          day: tempDay,
          month: tempMonth,
          date: tempDate,
          year: tempYear,
        };

        this.calenderRef = React.createRef();
        this.clickOutsideCalander = this.clickOutsideCalander.bind(this);
      }

      componentDidMount() {
        document.addEventListener("mousedown", this.clickOutsideCalander);
        let tempDay, tempMonth, tempDate, tempYear;

        [tempDay, tempMonth, tempDate, tempYear] = this.dateRanger(
          this.whichVal(this.state.today.day, "sun"),
          "current"
        ).split(" ");

        this.setStartDate(tempDay, tempMonth, tempDate, tempYear);

        [tempDay, tempMonth, tempDate, tempYear] = this.dateRanger(
          this.whichVal(this.state.today.day, "sat"),
          "current"
        ).split(" ");

        this.setState(
          {
            endDate: {
              day: tempDay,
              month: tempMonth,
              date: dateFormater(tempDate),
              year: tempYear,
            },
          },
          () => {
            this.getGym();
          }
        );
        this.setState({ weekDates: this.weekDates() });
      }

      componentWillUnmount() {
        document.removeEventListener("mousedown", this.clickOutsideCalander);
      }

      componentDidUpdate(prevProps, prevState) {
        if (prevProps.gymDataTrack !== this.props.gymDataTrack) {
          this.getGym();
        }

        if (prevProps.newWorkoutAdded !== this.props.newWorkoutAdded) {
          this.getWorkouts();
        }

        if (prevState.selectedDateRaw !== this.state.selectedDateRaw) {
          this.setState({ showCalendar: false });
        }
      }

      getGym = async () => {
        if (this.props.gymDataTrack.length > 0) {
          const tempOptions = this.props.gymDataTrack.map((currVal, index) => ({
            value: index,
            label: currVal.Name,
          }));

          const tempOptions1 = this.props.gymDataTrack[0].Tracks.map(
            (currVal, index) => ({
              value: currVal.Id,
              label: currVal.Name,
            })
          );
          await this.setState({
            options: tempOptions,
            selectedGym: this.props.gymDataTrack[0],
            tracks: this.props.gymDataTrack[0].Tracks,
            selectedTrack: this.props.gymDataTrack[0].Tracks[0],
            trackOptions: tempOptions1,
          });

          this.props.selectGym(this.props.gymDataTrack[0]);
          this.props.addTrack(this.props.gymDataTrack[0].Tracks[0]);
          this.getWorkouts();
        }
      };

      static getDerivedStateFromProps(newProps, prevProps) {
        let gymData = newProps.gymData;

        return {
          ...prevProps,
          gymData: gymData,
          gymDataTrack: newProps.gymDataTrack,
        };
      }

      getWorkouts = async () => {
        let url = `${projectSettings.baseUrl}/workouts/getworkouts`;
        let header = true;
        let data = null;
        let type = "POST";
        let token = getPlainToken();
        let response = "";

        let startingWeekDate = `${this.state.startDate.date} ${this.state.startDate.month} ${this.state.startDate.year}`;

        let endingWeekDate = `${this.state.endDate.date} ${this.state.endDate.month} ${this.state.endDate.year}`;

        if (
          (this.state.selectedTrack && this.state.selectedTrack.length) ||
          (this.state.selectedTrack && this.state.selectedTrack.Id)
        ) {
          let newFromDate = new Date(startingWeekDate);
          let newToDate = new Date(endingWeekDate);

          newFromDate = new Date(
            newFromDate.getTime() - newFromDate.getTimezoneOffset() * 60000
          );

          newToDate = new Date(
            newToDate.getTime() - newToDate.getTimezoneOffset() * 60000
          );

          data = {
            gymId: this.state.selectedGym.Id,
            trackId: this.state.selectedTrack.Id,
            fromDate: newFromDate,
            toDate: newToDate,
          };

          response = await callAPI(
            url,
            header,
            type,
            JSON.stringify(data),
            token
          );

          if (response) {
            this.setState({ isLoading: false });
            if (response.type === "error") {
              this.setState({ showError: true });
            } else if (response.type === "success") {
              this.setState({ workoutInfo: [] }, () => {
                this.formatTiles(response.data);
              });

              response = "";
            }
            this.props.calendarDateChanged(false);
          }
        }
      };

      calllingUpdatedWorkouts = () => {
        this.props.calendarDateChanged(true);
        this.getWorkouts();
      };

      changeSelectedTrack = (selectedTrackName) => {
        let reqTrack = this.state.tracks.filter((track) => {
          if (track.Name === selectedTrackName) {
            return track;
          }
        });

        this.setState({ selectedTrack: reqTrack[0] }, () => {
          this.props.addTrack(this.state.selectedTrack);
          this.props.calendarDateChanged(true);
          this.getWorkouts();
        });
      };

      formatTiles = (responce) => {
        const weekDates = this.weekDates();
        let _workouts = [];

        if (responce && !responce.length) {
          _workouts.push("", "", "", "", "", "", "");
        } else {
          let foundAtIndex;

          for (let i = 0; i <= 6; i++) {
            foundAtIndex = this.dateCompare(responce, new Date(weekDates[i]));
            if (responce && foundAtIndex) {
              _workouts.push(responce[foundAtIndex - 1].Workouts);
            } else {
              _workouts.push("");
            }
          }
        }
        this.setState({ workoutInfo: _workouts });
      };

      dateCompare = (repsonce, _date2) => {
        let date2 = _date2.getDate();
        let month2 = _date2.getMonth();
        let year2 = _date2.getFullYear();

        let _date1;
        let date1, month1, year1;
        let op = 0;

        for (let j = 0; j < repsonce.length; j++) {
          _date1 = new Date(repsonce[j].Date);

          date1 = _date1.getDate();
          month1 = _date1.getMonth();
          year1 = _date1.getFullYear();

          if (date1 === date2 && month1 === month2 && year1 === year2) {
            op = j + 1;
            return op;
          }
        }
        return op;
      };

      weekDates = () => {
        let { day, month, date, year } = this.state.startDate;
        let reqDate = new Date(year + "/" + months[month] + "/" + date);

        let dateArray = [];

        for (let i = 0; i < 7; i++) {
          let _date = new Date(year + "/" + months[month] + "/" + date);

          _date.setDate(reqDate.getDate() + i);
          dateArray.push(_date);
        }

        return dateArray;
      };

      updateSelectedDate = (tempDay, tempMonth, tempDate, tempYear) => {
        this.setState({
          selectedDate: {
            day: tempDay,
            month: tempMonth,
            date: dateFormater(tempDate),
            year: tempYear,
          },
        });
      };

      setStartDate = (tempDay, tempMonth, tempDate, tempYear) => {
        this.setState({
          startDate: {
            day: tempDay,
            month: tempMonth,
            date: dateFormater(tempDate),
            year: tempYear,
          },
        });
      };

      setEndDate = (tempDay, tempMonth, tempDate, tempYear) => {
        this.setState(
          {
            endDate: {
              day: tempDay,
              month: tempMonth,
              date: dateFormater(tempDate),
              year: tempYear,
            },
          },
          () => this.calllingUpdatedWorkouts()
        );
      };

      dateSelector = (selected) => {
        this.setState({ currentPosition: 0 });
        this.setState({ selectedDateRaw: selected.toDateString() });

        let tempDay, tempMonth, tempDate, tempYear, tempGap, selectedDay;
        [tempDay, tempMonth, tempDate, tempYear] = selected
          .toDateString()
          .split(" ");

        this.updateSelectedDate(tempDay, tempMonth, tempDate, tempYear);

        selectedDay = tempDay;

        tempGap = this.whichVal(selectedDay, "sun");

        [tempDay, tempMonth, tempDate, tempYear] = this.dateRanger(
          tempGap,
          selected.toDateString()
        ).split(" ");
        this.setStartDate(tempDay, tempMonth, tempDate, tempYear);

        tempGap = this.whichVal(selectedDay, "sat");

        [tempDay, tempMonth, tempDate, tempYear] = this.dateRanger(
          tempGap,
          selected.toDateString()
        ).split(" ");
        this.setEndDate(tempDay, tempMonth, tempDate, tempYear);
      };

      dateRanger = (val = 0, whichDate) => {
        let date;

        if (whichDate) {
          if (whichDate === "current") {
            date = new Date();

            date.setDate(date.getDate() + val);
            return date.toDateString();
          } else {
            date = new Date(whichDate);
            date.setDate(date.getDate() + val);
            return date.toDateString();
          }
        }
      };

      whichVal = (today, reqDay) => {
        today = today && today.toLowerCase();
        reqDay = reqDay && reqDay.toLowerCase();

        switch (today) {
          case "sun":
            if (reqDay === "sun") return 0;
            else if (reqDay === "mon") return 1;
            else if (reqDay === "tue") return 2;
            else if (reqDay === "wed") return 3;
            else if (reqDay === "thu") return 4;
            else if (reqDay === "fri") return 5;
            else if (reqDay === "sat") return 6;
          case "mon":
            if (reqDay === "sun") return -1;
            else if (reqDay === "mon") return 0;
            else if (reqDay === "tue") return 1;
            else if (reqDay === "wed") return 2;
            else if (reqDay === "thu") return 3;
            else if (reqDay === "fri") return 4;
            else if (reqDay === "sat") return 5;
          case "tue":
            if (reqDay === "sun") return -2;
            else if (reqDay === "mon") return -1;
            else if (reqDay === "tue") return 0;
            else if (reqDay === "wed") return 1;
            else if (reqDay === "thu") return 2;
            else if (reqDay === "fri") return 3;
            else if (reqDay === "sat") return 4;
          case "wed":
            if (reqDay === "sun") return -3;
            else if (reqDay === "mon") return -2;
            else if (reqDay === "tue") return -1;
            else if (reqDay === "wed") return 0;
            else if (reqDay === "thu") return 1;
            else if (reqDay === "fri") return 2;
            else if (reqDay === "sat") return 3;
          case "thu":
            if (reqDay === "sun") return -4;
            else if (reqDay === "mon") return -3;
            else if (reqDay === "tue") return -2;
            else if (reqDay === "wed") return -1;
            else if (reqDay === "thu") return 0;
            else if (reqDay === "fri") return 1;
            else if (reqDay === "sat") return 2;
          case "fri":
            if (reqDay === "sun") return -5;
            else if (reqDay === "mon") return -4;
            else if (reqDay === "tue") return -3;
            else if (reqDay === "wed") return -2;
            else if (reqDay === "thu") return -1;
            else if (reqDay === "fri") return 0;
            else if (reqDay === "sat") return 1;
          case "sat":
            if (reqDay === "sun") return -6;
            else if (reqDay === "mon") return -5;
            else if (reqDay === "tue") return -4;
            else if (reqDay === "wed") return -3;
            else if (reqDay === "thu") return -2;
            else if (reqDay === "fri") return -1;
            else if (reqDay === "sat") return 0;
        }
      };

      prevWeek = async () => {
        let prevPosition = this.state.currentPosition;

        await this.setState({ currentPosition: prevPosition - 7 });

        let tempDay, tempMonth, tempDate, tempYear;
        let val;

        val =
          this.whichVal(this.state.selectedDate.day, "sun") +
          this.state.currentPosition;

        [tempDay, tempMonth, tempDate, tempYear] = this.dateRanger(
          val,
          this.state.selectedDateRaw
        ).split(" ");

        this.setStartDate(tempDay, tempMonth, tempDate, tempYear);

        val =
          this.whichVal(this.state.selectedDate.day, "sat") +
          this.state.currentPosition;

        [tempDay, tempMonth, tempDate, tempYear] = this.dateRanger(
          val,
          this.state.selectedDateRaw
        ).split(" ");

        this.setEndDate(tempDay, tempMonth, tempDate, tempYear);
      };

      currentWeek = async () => {
        let tempDay, tempMonth, tempDate, tempYear;

        await this.setState({ currentPosition: 0 });

        await this.setState({ selectedDateRaw: "current" });

        this.updateSelectedDate(
          this.state.today.day,
          this.state.today.month,
          this.state.today.date,
          this.state.today.year
        );

        [tempDay, tempMonth, tempDate, tempYear] = this.dateRanger(
          this.whichVal(this.state.today.day, "sun"),
          "current"
        ).split(" ");

        this.setStartDate(tempDay, tempMonth, tempDate, tempYear);

        [tempDay, tempMonth, tempDate, tempYear] = this.dateRanger(
          this.whichVal(this.state.today.day, "sat"),
          "current"
        ).split(" ");

        this.setEndDate(tempDay, tempMonth, tempDate, tempYear);
      };

      nextWeek = async () => {
        let nextPositon = this.state.currentPosition;

        await this.setState({ currentPosition: nextPositon + 7 });

        let tempDay, tempMonth, tempDate, tempYear;

        [tempDay, tempMonth, tempDate, tempYear] = this.dateRanger(
          this.whichVal(this.state.selectedDate.day, "sun") +
            this.state.currentPosition,
          this.state.selectedDateRaw
        ).split(" ");

        this.setStartDate(tempDay, tempMonth, tempDate, tempYear);

        [tempDay, tempMonth, tempDate, tempYear] = this.dateRanger(
          this.whichVal(this.state.selectedDate.day, "sat") +
            this.state.currentPosition,
          this.state.selectedDateRaw
        ).split(" ");

        this.setEndDate(tempDay, tempMonth, tempDate, tempYear);
      };

      clickOutsideCalander(event) {
        if (
          this.calenderRef &&
          this.calenderRef.current &&
          !this.calenderRef.current.contains(event.target)
        ) {
          this.setState({
            showCalendar: false,
          });
        }
      }

      setDate = (date) => {
        this.setState({ workoutDate: date });
      };

      getDate = (reqDate) => {
        let tempDate = new Date(reqDate);
        let date = tempDate.getDate();
        let month = tempDate.getMonth();
        let year = tempDate.getFullYear();

        let newDate = `${month + 1}/${date}/${year}`;
        return newDate;
      };

      changeGym = async (index) => {
        const tempOptions = this.props.gymDataTrack[index].Tracks.map(
          (currVal, index) => ({
            value: currVal.Id,
            label: currVal.Name,
          })
        );

        await this.setState({
          trackOptions: tempOptions,
          tracks: this.props.gymDataTrack[index].Tracks,
          selectedTrack: this.props.gymDataTrack[index].Tracks[0],
          selectedGym: this.props.gymDataTrack[index],
        });

        this.props.selectGym(this.props.gymDataTrack[index]);
        this.props.addTrack(this.props.gymDataTrack[index].Tracks);

        this.props.calendarDateChanged(true);
        this.getWorkouts();
      };

      updateWorkout = async (data, trackWorkoutId, newDestinationTile) => {
        let url = `${projectSettings.baseUrl}/workouts/update/${trackWorkoutId}`;
        let header = true;
        let type = "POST";
        let token = getPlainToken();

        data.SortedWorkouts = newDestinationTile;

        let response = "";

        if (response === "") {
        }

        response = await callAPI(
          url,
          header,
          type,
          JSON.stringify(data),
          token
        );

        if (response) {
          apiResponseToast(
            response.status,
            "editWorkout",
            response.data.message
          );

          if (response.status === 403) {
          } else if (response.type === "error") {
          } else if (response.type === "success") {
            response = "";
          }
        }
      };

      onDragEnd = (result) => {
        const { source, destination, draggableId } = result;
        let weekDates = this.weekDates();

        let draggedWorkout = this.getDataOfDraggedWorkout(draggableId);

        if (draggedWorkout && destination) {
          let updatedDraggableWorkout = draggedWorkout;

          let newFromDate = new Date(
            weekDates[parseInt(destination.droppableId)]
          );
          newFromDate = new Date(
            newFromDate.getTime() - newFromDate.getTimezoneOffset() * 60000
          );

          updatedDraggableWorkout.Workout.Schedule = newFromDate;
          updatedDraggableWorkout.Workout.SortOrder = destination.index + 1;

          let tempWorkout = this.removeOldIndex(
            parseInt(source.droppableId),
            updatedDraggableWorkout
          );

          let newDestinationTile = this.addToNewIndex(
            parseInt(destination.droppableId),
            updatedDraggableWorkout,
            tempWorkout,
            destination.index
          );

          this.updateWorkout(
            updatedDraggableWorkout.Workout,
            updatedDraggableWorkout.TrackWorkoutId,
            newDestinationTile
          );
        }
      };

      removeOldIndex(index, data) {
        let _workoutInfo = this.state.workoutInfo;
        let workoutOfTile;

        for (let i = 0; i < this.state.workoutInfo.length; i++) {
          workoutOfTile = this.state.workoutInfo[i];

          if (workoutOfTile.length) {
            for (let j = 0; j < workoutOfTile.length; j++) {
              if (
                parseInt(data.TrackWorkoutId) ===
                workoutOfTile[j].TrackWorkoutId
              ) {
                _workoutInfo[i].splice(j, 1);
              }
            }
          }
        }

        return _workoutInfo;
      }

      addToNewIndex(index, data, wokrout, destinationIndex) {
        let _workoutInfo = wokrout;

        if (_workoutInfo[index]) {
          _workoutInfo[index].splice(destinationIndex, 0, data);
        } else {
          _workoutInfo[index] = [data];
        }

        this.setState({ workoutInfo: _workoutInfo });

        let newDestinationTile = this.createArrayOfDestinationTile(
          _workoutInfo,
          index
        );

        return newDestinationTile;
      }

      createArrayOfDestinationTile(workout, index) {
        let destinationTile = workout[index];

        let newArray = destinationTile.map((currVal, index) => {
          return {
            TrackWorkoutId: currVal.TrackWorkoutId,
            SortOrder: index + 1,
          };
        });

        return newArray;
      }

      getDataOfDraggedWorkout = (id) => {
        let workoutOfTile;

        for (let i = 0; i < this.state.workoutInfo.length; i++) {
          workoutOfTile = this.state.workoutInfo[i];

          if (workoutOfTile.length) {
            for (let j = 0; j < workoutOfTile.length; j++) {
              if (parseInt(id) === workoutOfTile[j].TrackWorkoutId) {
                return workoutOfTile[j];
              }
            }
          }
        }
      };

      forward = () => {
        this.setState({ showJoinGym: 1 });
      };

      back = () => {
        this.setState({ showJoinGym: 0 });
      };

      resetOnCloseModal = () => {
        this.setState({ showJoinGym: 0, isShowViewWorkoutModal: false }, () =>
          this.setDate(new Date())
        );
      };
      handleWokoutModal = (isShow) => {
        this.setState({
          isShowViewWorkoutModal: isShow,
        });
      };
      render() {
        const daysOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

        return (
          <>
            <div
              className={`${style.container} ${
                getSubscription() === "true"
                  ? style.containerHeight2
                  : style.containerHeight1
              }`}
            >
              <header
                className={`navbar-menu-wrapper flexContianer  mt-2 mb-4 mr-1 ml-1 pl-2 pr-2 ${style.programmingCalenderNavBar}`}
              >
                <div className="mt-4">
                  <button
                    className="width-fit-content hollowBtn"
                    onClick={this.prevWeek}
                  >
                    <i className="mdi mdi-arrow-left"></i>
                  </button>
                  <button
                    className="basicBtnStyle primaryBtn ml-2"
                    onClick={this.currentWeek}
                  >
                    Today
                  </button>
                  <button
                    className="width-fit-content hollowBtn ml-2"
                    onClick={this.nextWeek}
                  >
                    <i className="mdi mdi-arrow-right"></i>
                  </button>
                </div>
                <div className="position-relative " ref={this.calenderRef}>
                  <div
                    className={`h3 pointerCursor mt-4 ${style.calenderDate}`}
                    onClick={() => {
                      this.setState({
                        showCalendar: !this.state.showCalendar,
                      });
                    }}
                  >
                    {`
                    ${this.state.startDate.month} ${this.state.startDate.date},
                    ${this.state.startDate.year} - 
                    ${this.state.endDate.month} ${this.state.endDate.date},
                    ${this.state.endDate.year}`}
                    <img className={`${style.arrowdown}`} src={arrowdown} />
                  </div>

                  {this.state.showCalendar ? (
                    <div className="dateDropDownBox shadow">
                      <Calendar
                        onChange={this.dateSelector}
                        className="dateDropDown"
                        disableOnClickOutside={true}
                        value={new Date()}
                      />
                    </div>
                  ) : null}
                </div>
                <div className={`flexContianer ${style.navbarTracks}`}>
                  {this.props.userData.Role === "athlete" && (
                    <div className="mr-3 mb-0">
                      <div className="mb-1">Gyms</div>
                      <Select
                        className={`react-select ${style.trackSelect} zIndex4`}
                        placeholder="Gyms"
                        value={{
                          label:
                            this.state.selectedGym &&
                            this.state.selectedGym.Name,
                        }}
                        options={this.state.options}
                        onChange={(selctedOption) => {
                          this.setState(this.changeGym(selctedOption.value));
                        }}
                      />
                    </div>
                  )}
                  <div className="mr-3 mb-0">
                    <div className="mb-1">Tracks</div>
                    <Select
                      className={`react-select ${style.trackSelect} zIndex4`}
                      placeholder="Tracks"
                      value={{
                        label:
                          this.state.selectedTrack &&
                          this.state.selectedTrack.Name,
                      }}
                      options={this.state.trackOptions}
                      onChange={(selctedOption) => {
                        this.setState(
                          this.changeSelectedTrack(selctedOption.label)
                        );
                      }}
                    />
                  </div>
                  {this.props.userData.Role === "owner" && (
                    <button
                      className={`basicBtnStyle primaryBtn mt-4 pt-2 pb-2 pl-2 pr-3 m-0 mr-3 ${style.addWorkoutBtn}`}
                      data-toggle="modal"
                      data-target="#addWorkout"
                      disabled={!this.state.tracks.length}
                      onClick={() => this.handleWokoutModal(true)}
                    >
                      <i className="mdi mdi-plus menu-icon colorWhite pl-1 pr-1"></i>
                      Add Workout
                    </button>
                  )}
                </div>
              </header>
              <main className="content-wrapper colorBgTransparent pb-0 pt-0 ml-0 mr-0 pl-0 pr-0">
                {this.state.tracks.length ? null : (
                  <div
                    className={`overlayMessage ${
                      getSubscription() === "true"
                        ? "overlayMessageHeight2"
                        : "overlayMessageHeight1"
                    }`}
                  >
                    {this.props.trackLoading ? (
                      <Spinner size="size100" />
                    ) : this.props.userData.Role === "athlete" ? (
                      <>
                        <span className="h1">No Tracks Joined</span>
                        <br />
                        <button
                          className="basicFatBtnStyle primaryBtn mt-4"
                          data-toggle="modal"
                          data-target="#joinTrack"
                        >
                          <i className="mdi mdi-plus menu-icon colorWhite pl-1 pr-1"></i>
                          Join Track
                        </button>
                      </>
                    ) : (
                      <>
                        <span className="h1">No Tracks Found</span>
                        <br />
                        <button
                          className="basicFatBtnStyle primaryBtn mt-4"
                          data-toggle="modal"
                          data-target="#addTracks"
                        >
                          <i className="mdi mdi-plus menu-icon colorWhtie pl-1 pr-1"></i>
                          Add Tracks
                        </button>
                      </>
                    )}
                  </div>
                )}
                {/* showing tiles based on dates */}
                <DragDropContext onDragEnd={this.onDragEnd}>
                  <div
                    id={style.displayedWeek}
                    className={style.allTilesContaier}
                  >
                    {this.state.workoutInfo &&
                      [...Array(daysOfWeek.length)].map((currVal, index) => (
                        <Droppable
                          droppableId={index.toString()}
                          index={index}
                          key={index.toString()}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              className={`float-left ${style.tileContainer}`}
                            >
                              <Tile
                                key={index}
                                date={this.dateRanger(
                                  this.whichVal(
                                    this.state.selectedDate.day,
                                    daysOfWeek[index]
                                  ) + this.state.currentPosition,
                                  this.state.selectedDateRaw
                                )}
                                today={{
                                  date: this.state.today.date,
                                  month: this.state.today.month,
                                }}
                                isTracksLoading={this.state.tracks.length}
                                track={this.state.selectedTrack}
                                workouts={this.state.workoutInfo[index]}
                                showSubscriptionEnded={getSubscription()}
                              />
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      ))}
                  </div>
                </DragDropContext>
              </main>

              {/* Workout Modal */}
              <div
                className="modal fade"
                id="addWorkout"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                data-backdrop="static"
                data-keyboard="false"
              >
                <div
                  className="modal-dialog basicFormStyle  updateModalDialog "
                  role="document"
                >
                  <div className="modal-content modalContainer1 border-0 ">
                    <div class="modal-header">
                      <div className="d-flex">
                        <h5 class="modal-title">Add Workout</h5>
                      </div>
                      <div>
                        {/* Cross Button to close modal */}
                        <button
                          type="button"
                          className="noBgBtn"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={this.resetOnCloseModal}
                        >
                          <span
                            aria-hidden="true"
                            className="mdi mdi-close"
                          ></span>
                        </button>
                      </div>
                    </div>
                    <div class="modal-body">
                      <div class="border rounded inputFieldStyle">
                        {/*  */}
                        <DatePicker
                          clearIcon={null}
                          onChange={(value) => {
                            this.setDate(value);
                          }}
                          value={new Date(this.state.workoutDate)}
                          className="form-control form-control-sm colorBgWhite p-0"
                        />
                      </div>
                      <div className="d-flex justify-content-between mt-2 mb-2">
                        <button
                          className={`basicBtnStyle p-2 workOutBtn ${
                            this.state.showCustomWorkout
                              ? "primaryBtn"
                              : "quaternaryBtn"
                          }`}
                          onClick={() => {
                            this.setState({
                              showCustomWorkout: true,
                              showLift: false,
                              showFromDB: false,
                            });
                          }}
                        >
                          Custom Workout
                        </button>
                        <button
                          className={`basicBtnStyle p-2 workOutBtn ${
                            this.state.showLift ? "primaryBtn" : "quaternaryBtn"
                          }`}
                          onClick={() => {
                            this.setState({
                              showCustomWorkout: false,
                              showLift: true,
                              showFromDB: false,
                            });
                          }}
                        >
                          Lift
                        </button>
                        <button
                          className={`basicBtnStyle p-2 workOutBtn ${
                            this.state.showFromDB
                              ? "primaryBtn"
                              : "quaternaryBtn"
                          }`}
                          onClick={() => {
                            this.setState({
                              showCustomWorkout: false,
                              showLift: false,
                              showFromDB: true,
                            });
                          }}
                        >
                          From Database
                        </button>
                      </div>
                      <div className="dropdown-divider"></div>
                      <div className="modal-scroll primaryScrollBar">
                        {this.state.isShowViewWorkoutModal &&
                        this.state.showCustomWorkout ? (
                          <CustomWorkout
                            modalId="addWorkout"
                            workoutDate={this.state.workoutDate}
                            resetOnCloseModal={this.resetOnCloseModal}
                          />
                        ) : this.state.isShowViewWorkoutModal &&
                          this.state.showLift ? (
                          <Lift
                            modalId="addWorkout"
                            workoutDate={this.state.workoutDate}
                            resetOnCloseModal={this.resetOnCloseModal}
                          />
                        ) : this.state.showFromDB ? (
                          <p>
                            <FromDatabase
                              modalId="addWorkout"
                              workoutDate={this.state.workoutDate}
                              resetOnCloseModal={this.resetOnCloseModal}
                            />
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Workout modal ends */}            

              {/* Join Track */}
              <div
                className="modal fade"
                id="joinTrack"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                data-backdrop="static"
                data-keyboard="false"
              >
                <div className="basicFormStyle modal-dialog" role="document">
                  <div className="modal-content modalContainer1">
                    <div className="modal-header modalHeader colorWhite">
                      {this.state.showJoinGym ? (
                        <button
                          className={`noBgBtn mr-2 ${
                            this.state.gymTrack === 1 && "d-none"
                          }`}
                          onClick={() => {
                            this.back();
                          }}
                        >
                          <span className="mdi mdi-arrow-left mr-2 pl-0 ml-0"></span>
                        </button>
                      ) : null}
                      <div className="h3 mr-auto mb-0" id="exampleModalLabel">
                        Join Track
                      </div>
                      <div>
                        {/* Cross Button to close modal */}
                        <button
                          type="button"
                          className="noBgBtn"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={this.resetOnCloseModal}
                        >
                          <span
                            aria-hidden="true"
                            className="mdi mdi-close"
                          ></span>
                        </button>
                      </div>
                    </div>
                    <div className="modal-body">
                      {!this.state.showJoinGym ? (
                        <JoinGym
                          move={this.forward}
                          resetOnCloseModal={this.resetOnCloseModal}
                        />
                      ) : (
                        <JoinTrack
                          modalId="joinTrack"
                          resetOnCloseModal={this.resetOnCloseModal}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Join Track ends */}
            </div>
          </>
        );
      }
    }
  )
);
